export default __webpack_public_path__ + "static/media/newAsset 7.e0e58c92.png";